import { useMemo } from 'react';
import { Field,FieldTypes } from '@common-fe/common-fe';
import _ from 'lodash';
import * as yup from 'yup';

import { REQUIRED_TEXT } from '@/common/constants';
import { StatementFeePaidByType } from '@/modules/employer/components/SetupEmployer/Communication/Communication.types';
import { EmployerDto } from '@/modules/employer/types';

import { useHideFields } from '../../hooks';

const MIN_AMOUNT = 0.01;

const usePaperStatementsFeesFields = (data?: EmployerDto, isAdminFees?: boolean) => {
  const statementFeePaidBy = useMemo(
    () => data?.overridableProperties?.paperStatementFeesPaidBy,
    [data],
  );
  const statementFeeAmount = useMemo(
    () => data?.overridableProperties?.paperStatementFeesAmount,
    [data],
  );

  const fields = useMemo(() => [
    {
      name: 'paperStatementFeesPaidBy',
      type: FieldTypes.Radio,
      label: 'Paid By',
      options: [
        { label: 'Participant', value: StatementFeePaidByType.PARTICIPANT },
        { label: 'Admin', value: StatementFeePaidByType.ADMIN },
      ],
      defaultValue: statementFeePaidBy,
      showRequireIcon: true,
      validator: yup.string().required(REQUIRED_TEXT),
    },
    ...(isAdminFees ? [] : [{
      name: 'paperStatementFeesAmount',
      type: FieldTypes.Currency,
      label: 'Amount',
      defaultValue: statementFeeAmount,
      value: statementFeeAmount,
      showRequireIcon: true,
      validator: yup.string()
        .test({
          test: (val) => {
            if (_.toNumber(val) < MIN_AMOUNT) return false;
            return true;
          },
          message: `Amount must be greater than $${MIN_AMOUNT}`,
        }).required(REQUIRED_TEXT),
    }]),
  ], [statementFeePaidBy, statementFeeAmount, isAdminFees]);
  const formattedFields = useHideFields(fields as Field[]);
  return formattedFields;
};

export default usePaperStatementsFeesFields;
